import "@/App.css";
import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AdminProvider, useAdmin } from "@/context/AdminContext";
import { trackVisit } from "@/lib/api";
import Navbar from "@/components/Navbar";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function RequireAdmin({ children }) {
  const { isAuthed } = useAdmin();
  const location = useLocation();
  if (!isAuthed) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return children;
}

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  useEffect(() => {
    if (!location.pathname.startsWith("/admin")) trackVisit();
  }, [location.pathname]);
  return (
    <div className="App grain">
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/produs/:slug" element={<ProductDetail />} />
        <Route path="/legal/:slug" element={<Legal />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
      </Routes>
      {!isAdmin && <CartDrawer />}
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#E6E1D8",
            border: "1px solid #D6D1C8",
            color: "#0E0F12",
            borderRadius: "2px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <CartProvider>
        <AdminProvider>
          <BrowserRouter>
            <Shell />
          </BrowserRouter>
        </AdminProvider>
      </CartProvider>
    </ReactLenis>
  );
}

export default App;
